import zhCn from 'element-plus/es/locale/lang/zh-cn'

import { defineAdminLocale } from '../locale-definition'
import { adminMessages } from '../messages'

export default defineAdminLocale({
  code: 'zh-CN',
  name: '简体中文',
  order: 10,
  elementPlusLocale: zhCn,
  messages: adminMessages.zh
})
